"use client"

import { useState, useEffect } from "react"

export default function AgeVerification() {
  const [isOfAge, setIsOfAge] = useState(false)
  const [hasAnswered, setHasAnswered] = useState(false)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    // Check if age verification is stored in local storage
    try {
      const storedAgeVerification = localStorage.getItem("isOfAge")
      if (storedAgeVerification === "true") {
        setIsOfAge(true)
        setHasAnswered(true)
      } else if (storedAgeVerification === "false") {
        setHasAnswered(true)
      } else {
        // Trigger animation after mount
        setTimeout(() => setIsVisible(true), 100)
      }
    } catch (error) {
      console.error("Error checking age verification:", error)
      setHasAnswered(true)
    }
  }, [])

  const handleYes = () => {
    setIsVisible(false)
    setTimeout(() => {
      setIsOfAge(true)
      setHasAnswered(true)
      localStorage.setItem("isOfAge", "true")
    }, 300)
  }

  const handleNo = () => {
    setIsOfAge(false)
    setHasAnswered(true)
    localStorage.setItem("isOfAge", "false")
    window.location.href = "https://www.google.com"
  }

  if (!hasAnswered) {
    return (
      <div className={`fixed inset-0 z-[99999] flex items-center justify-center transition-all duration-300 ${isVisible ? 'opacity-100' : 'opacity-0'}`} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }}>
        {/* Green tinted backdrop with blur - covers everything */}
        <div className="fixed inset-0 bg-gradient-to-br from-green-950/98 via-black/95 to-green-900/98 backdrop-blur-lg" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }} />
        
        {/* Decorative blur circles */}
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-primary_green/20 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-emerald-600/15 rounded-full blur-3xl" />
        
        {/* Modal */}
        <div className={`relative z-10 w-full max-w-md mx-4 transition-all duration-500 ${isVisible ? 'scale-100 translate-y-0' : 'scale-95 translate-y-4'}`}>
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
            {/* White Header with Logo */}
            <div className="bg-white px-8 pt-8 pb-6 text-center border-b border-gray-100">
              {/* Logo - raw, no background */}
              <img
                src="/images/716-cannabis-logo-new.png"
                alt="716 Cannabis"
                className="w-32 h-32 mx-auto mb-3 object-contain"
              />
              <h1 className="text-gray-900 text-xl font-bold">716 Cannabis</h1>
              <p className="text-gray-500 text-sm mt-1">Buffalo's Premier Dispensary</p>
            </div>
            
            {/* Green Content Area */}
            <div className="bg-gradient-to-br from-primary_green to-emerald-600 px-8 py-8 text-center">
              <div className="mb-6">
                <h2 className="text-2xl font-bold text-white mb-2">Age Verification</h2>
                <p className="text-green-100">
                  You must be <span className="font-bold text-white">21 years or older</span> to enter this website.
                </p>
              </div>
              
              <p className="text-sm text-green-100/80 mb-6">
                By clicking below you confirm you are of legal age to view cannabis products.
              </p>
              
              {/* Buttons */}
              <div className="space-y-3">
                <button
                  onClick={handleYes}
                  className="w-full bg-white hover:bg-gray-50 text-primary_green font-bold py-4 px-6 rounded-xl text-lg transition-all duration-200 hover:shadow-lg active:scale-[0.98]"
                >
                  Yes, I am 21+
                </button>
                <button 
                  onClick={handleNo}
                  className="w-full bg-white/10 hover:bg-white/20 text-white font-medium py-3 px-6 rounded-xl transition-all duration-200 border border-white/20"
                >
                  No, I am not
                </button>
              </div>
              
              {/* Footer note */}
              <p className="text-xs text-green-100/60 mt-6">
                Please consume responsibly.
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return null
}
